module.exports = __webpack_public_path__ + "img/80432693000120.8ca0fda9.png";